import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, keyframes, Typography } from "@mui/material";
import LevelsProgressBar from "../components/LevelsProgressBar";
import Arrowright from "../images/Arrowright.svg";
import bronze from "../images/Bronze.svg";
import silver from "../images/Silver.svg";
import Gold from '../images/GoldLeague.svg'
import Platinum from '../images/PlatinumLeuages.svg'
import Diamond  from '../images/DiamondLeague.svg'
import star_background from "../images/Star_background.svg"
import { setLevelsData } from "../Apis";
import { FunctionCommas } from "../utils/commasFun";
import KlinkToken from '../images/Klink-Coin.svg'

const Levels = () => {
  const userLeague = useSelector((state) => state?.user?.userData?.league);
  const userId = useSelector((state) => state.user.userId);
  const currentPoint = useSelector((state) => state?.point?.currentPoint);
  const userleaguesData = useSelector((state) => state?.user?.userLevelData);
  // const userBonusperLevel = useSelector((state) => state?.user?.userLevelData.levelUpBonus)
  const accessToken = useSelector((state)=>state?.user?.accessToken)
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLevelsData(userId,accessToken));
  }, [dispatch, userId]);

  const data = [
    {
      league: "Bronze",
      title: "Bronze League",
      subTitle: "Your number of shares determines the league you enter",
      img: bronze,
      userBonusperLevel: 1000,
      minShares: currentPoint,
      maxShares: userleaguesData?.Bronze?.leagueTo,
    },
    {
      league: "Silver",
      title: "Silver League",
      subTitle: "Your number of shares determines the league you enter",
      userBonusperLevel: 10000,
      img: silver,
      minShares: currentPoint,
      maxShares: userleaguesData?.Silver?.leagueTo,
    },
    {
      league: "Gold",
      title: "Gold League",
      subTitle: "Your number of shares determines the league you enter",
      userBonusperLevel: 25000,
      img: Gold,
      minShares: currentPoint,
      maxShares: userleaguesData?.Gold?.leagueTo,
    },
    {
      league: "Platinum",
      title: "Platinum League",
      subTitle: "Your number of shares determines the league you enter",
      userBonusperLevel: 750000,
      img: Platinum,
      minShares: currentPoint,
      maxShares: userleaguesData?.Platinum?.leagueTo,
    },
    {
      league: "Diamond",
      title: "Diamond League",
      subTitle: "Your number of shares determines the league you enter",
      userBonusperLevel: 200000,
      img: Diamond,
      minShares: currentPoint,
      maxShares: userleaguesData?.Diamond?.leagueTo,
    },
    // Add more leagues here if needed
  ];

  const userLevelData = data.find((level) => level.league === userLeague);
  const [index, setIndex] = useState(data.indexOf(userLevelData));

  const handleLeftClick = () => {
    if (index >= 1) {
      setIndex((prev) => prev - 1);
    }
  };

  const handleRightClick = () => {
    if (index < data.length - 1) {
      setIndex((prev) => prev + 1);
    }
  };

  const isActiveLeague = data[index]?.league === userLeague;

  let touchStartX = 0;
  let touchEndX = 0;

  const handleTouchStart = (e) => {
    touchStartX = e.targetTouches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX = e.targetTouches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (touchStartX - touchEndX > 50) {
      handleRightClick();
    }

    if (touchEndX - touchStartX > 50) {
      handleLeftClick();
    }
  };
  const scaleUp = keyframes`
  0% {
    transform: scale(0);
}

50% {
    transform: scale(0.8);
}

100%{
 transform: scale(1);
}
`;

  return (
    <Box
      sx={{
        height: "100vh",
        zIndex: 10,
        backgroundColor: "transparent",
      }}
    >
      <Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            paddingTop: "29px",
            gap: "22px",
            paddingRight: "23px",
            paddingLeft: "23px",
          }}
        >
          {/* Level name */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              gap: "12px",
              width: "267px",
            }}
          >
            <Typography
              component="p"
              sx={{
                color: "#FFF",
                fontWeight: 800,
                fontSize: "24px",
                lineHeight: "28.8px",
                fontFamily: "Inter",
                textAlign: "center",
              }}
            >
              {data[index]?.title}
            </Typography>
            <Typography
              component="p"
              sx={{
                color: "#FFF",
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "16.94px",
                fontFamily: "Inter",
                textAlign: "center",
              }}
            >
              {data[index]?.subTitle}
            </Typography>
            <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "5px",
            }}
          >
   
              <img src={KlinkToken} width={16} height={16} />


      
            <Typography
              sx={{
                color: "#FFFFFF",
                fontSize: "18px",
                fontWeight: 700,
                lineHeight: "21.78px",
               
              }}
            >
          {FunctionCommas(data[index]?.userBonusperLevel)} Bonus

            </Typography>


          </Box>
          </Box>

          {/* Level icon */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "20px",
              width: "310px",
              height: "310px",
              marginX: "auto",
              justifyContent: "center",
            }}
          >
            <img
              onClick={handleLeftClick}
              src={Arrowright}
              width={64}
              alt="Arrowright"
              height={64}
              style={{ rotate: "180deg" }}
            />
            <img
              src={data[index]?.img}
       

              height={186.01}
              alt="level_icon"
              width={186}
              style={{ position: "relative", filter: 'drop-shadow(12px 12px 20px #e8b5ff23) drop-shadow(-12px 12px 20px #e8b5ff23) drop-shadow(12px -12px 20px #e8b5ff23) drop-shadow(-12px -12px 20px #e8b5ff23)'}}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
            
            />
            <img
              onClick={handleRightClick}
              src={Arrowright}
              width={64}
              alt="Arrowleft"
              height={64}
            />
          </Box>

          {/* Progress bar */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              gap: "15px",
              position: "fixed",
              top: "490px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "3px",
              }}
            >
              {!isActiveLeague && (
                <Typography
                  sx={{
                    color: "#FFF",
                    fontWeight: 700,
                    fontSize: "18px",
                    lineHeight: "21.78px",
                    fontFamily: "Inter",
                    textAlign: "center",
                  }}
                >
                Reach  {FunctionCommas(data[index]?.maxShares)}
                </Typography>
              )}

              {isActiveLeague && (
                <>
                  <Typography
                    sx={{
                      color: "#FFF",
                      fontWeight: 700,
                      fontSize: "18px",
                      lineHeight: "21.78px",
                      fontFamily: "Inter",
                      textAlign: "center",
                    }}
                  >
                    {currentPoint} {/* Display current points */}
                  </Typography>
                  <Typography
                    sx={{
                      color: "#FFF",
                      fontWeight: 400,
                      fontSize: "12px",
                      lineHeight: "14.52px",
                      fontFamily: "Inter",
                      textAlign: "center",
                    }}
                  >
                    / {/* Separator */}
                  </Typography>
                  <Typography
                    sx={{
                      color: "#FFF",
                      fontWeight: 400,
                      fontSize: "12px",
                      lineHeight: "14.52px",
                      fontFamily: "Inter",
                      textAlign: "center",
                    }}
                  >
                    {data[index]?.maxShares} {/* Display max shares */}
                  </Typography>
                </>
              )}
            </Box>

            {isActiveLeague && (
              <LevelsProgressBar
                value={currentPoint} 
                max={data[index]?.maxShares} 
              />
            )}
          </Box>
        </Box>
      </Box>
      
      <img src={star_background} style={{ position: "absolute",    animation: `${scaleUp} 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)`, zIndex: -1, top: 0, bottom: 0, right: 0, left: 0, width: "100%", height: "100%", }} />
    </Box>
  );
};

export default Levels;
